// eslint-disable-next-line import/no-anonymous-default-export
export default {
    PendenteCiencia: 0,
    PendenteResposta: 1,
    PendenteTriagem: 2,
    PendenteLiberacao: 3,
    RespondidaEncerrada: 4
}